import ScanAgainstSuspendPanel from "./scanAgainstSuspendPanel.container";

export default ScanAgainstSuspendPanel;
